export var constants = {
	speakers: {
		ChargeNurse: {
			name: 'Charge Nurse',
			img: 'sampleimg.png'
		},
		OtherPerson: {
			name: 'Other Person',
			img: 'sampleimg.png'
		}
	},

	icons: {
		phone: './assets/images/general/icons/phone.png',
		feedback: './assets/images/general/icons/phone.png',
        miranda: './assets/images/general/icons/miranda.png',
        marco: './assets/images/general/icons/marco.png',
        nurseManager: './assets/images/general/components/general_alert/frame_mentor.png',
        computer: './assets/images/general/icons/computer_icon.png'
    },
    uiTags: {
        Hud: 'Hud',
		PrUi: 'PrUi',
		TaUi: 'TaUi'
    },
    generalAudio: {
        cellPhone: './assets/audio/general/CellPhone'
	},

	uiNames: {
		BeginScenarioUI: 'BeginScenarioUI',
		SplashScreenUI: 'SplashScreenUI',
        HeaderUI: 'HeaderUI',
		FooterUI: 'FooterUI',
        FailUI: 'FailUI',
		ModalPopUI: 'ModalPopUI',
		FeedbackUI: 'FeedbackUI',
		ProviderFeedbackUI: 'ProviderFeedbackUI',
        PatientRecordUI: 'PatientRecordUI',
        BadgingProgressUI: 'BadgingProgressUI',
        ResumeUI: 'ResumeUI',
        ReturnToMainMenuUI: 'ReturnToMainMenuUI',
        DelegateUI: 'DelegateUI',
		RememberUI: 'RememberUI',
		TalksActionsUI: 'TalksActionsUI',
		TransformUI: 'TransformUI',
		ConfirmAlertUI: 'ConfirmAlertUI',
		SbarUI: 'SbarUI',
		FullPageQuizUI: 'FullPageQuizUI'
	},
	
	scenarios: {
		scenario1: {
			id: 'Scenario1',
			parts: {
				level1Part1: {
					id: 'level1Part1'
				},
				level1Part2: {
					id: 'level1Part2'
				},
				level1Part3: {
					id: 'level1Part3'
				},
				level1Part4: {
					id: 'level1Part4'
				},
				level1Part5: {
					id: 'level1Part5'
				},
				level1Part6: {
					id: 'level1Part6'
				},
				level1Part7: {
					id: 'level1Part7'
				},
				level1Part8: {
					id: 'level1Part8'
				}
			}
		},
		scenario2: {
			id: 'Scenario2',
			parts: {
				level2Part1: {
					id: 'level2Part1'
				},
				level2Part2: {
					id: 'level2Part2'
				},
				level2Part3: {
					id: 'level2Part3'
				},
				level2Part4: {
					id: 'level2Part4'
				},
				level2Part5: {
					id: 'level2Part5'
				},
				level2Part6: {
					id: 'level2Part6'
				},
				level2Part7: {
					id: 'level2Part7'
				},
				level2Part8: {
					id: 'level2Part8'
				},
				level2Part9: {
					id: 'level2Part9'
				}
			}
		}
	}
};